import './Typography.scss';

export const Typography = ({
  children,
  variant = 'body-5',
  fontWeight = 'normal',
  color,
  style,
  className,
}: {
  children: React.ReactNode;
  variant?: 'body-1' | 'body-3' | 'body-5' | 'body-7' | 'body-8';
  fontWeight?: 'extra-light' | 'light' | 'normal' | 'semibold' | 'bold';
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}) => {
  return (
    <p className={`typography__${fontWeight} typography__${variant} ${className || ''}`} style={{ color: color || 'inherit', margin: 0, ...style }}>
      {children}
    </p>
  );
};
